//
// Activity.js
// - ------------------------------------------------------
// - Functions to support the Healify Wellness activity card maker
// - ------------------------------------------------------
//
// A UX prototype to allow users to create interactive wellness cards, for publishing to Facebook
// Including a wizard flow for card creation

// imports for image paths
import * as imageURL from "../img/illustrations/activities/*.png";
import { isSignedIn } from "./auth.js";
import { isPreRegistration } from "./moodAndFood.js";
var Airtable = require('airtable');
var base = new Airtable({apiKey: 'keyCv10aSA2Vxn4Ch'}).base('appKMHuPgfJLToeN1');

// getUrlVars
// Get variables from a Url formatted like https://page.html?var1=foo&var2=bar
function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
}

// insert Param - parse the URL looking at each parameter, and add the new parameter or update the value if it already exists
function insertParam(key, value) {
    key = encodeURIComponent(key);
    value = encodeURIComponent(value);

    // kvp looks like ['key1=value1', 'key2=value2', ...]
    const pageUrl = document.location.href;
    var kvp = pageUrl.includes('?') ? pageUrl.split('?')[1].split('&') : []; // the params as an array or an empty array if no params

    // iterate through the array, to add params and swap old param value with new value if necessary
    let i=0;
    for(; i<kvp.length; i++){
        if (kvp[i].startsWith(key + '=')) {
            let pair = kvp[i].split('=');
            pair[1] = value;
            kvp[i] = pair.join('=');
            break;
        }
    }

    if(i >= kvp.length){
        kvp[kvp.length] = [key,value].join('=');
    }

    // return the URL
    let params = kvp.join('&');
    var pageUrlCleaned = pageUrl.split('?')[0]; // cleaned up Url without params
    const fullUrl = pageUrlCleaned + '?' + params;
    history.pushState(null, null, fullUrl);
    return params;
    // reload page with new params
    // document.location.search = params;
}

// navigation
// control page navigation elements and routes, if they exist on page
function navigation(){
  // handle the dynamic URL rewriting and partial page redrawing
  window.addEventListener('popstate', function(event) {
    var category = getCategoryFromUrl();
    redrawCards(category);
    redrawSelector(category);
  });

  // handle the close button
  $('#close-toggle-activity').click(function(){
    window.location = "activity.html";
  });
}

// cardSelection - wire up the card selection process
function cardSelection(){
  $('#select-page .card').click(function(){ // when user clicks to select a card:
    var data = getCardActivity($(this)); // get the card's activity
    moveToWizardStep(2,data); // advance to next step to customize card
  });
}

  // redrawSelector - select a category in the category selector based on a URL parameter
function redrawSelector(category){
  $('#category_picker').val(category);
}

// categorySelection - wire up the category selection process
function categorySelection(){
  if (isPreRegistration()) $('#option_challenges').remove(); // remove the challenge picker during m&f pre-reg
  $('#category_picker').change(function(){ // when user clicks to change the category:
    var selected_category = $(this).val(); // get the selected category
    // console.log(selected_category, "category");
    insertParam("category", selected_category); // update URL
    redrawCards(selected_category); // redraw cards
  });
}

function getCategoryFromUrl(){
  var url_vars = getUrlVars();
  if (!url_vars.category) url_vars.category = "popular"; // set "popular" as the default category to draw if no category exists in URL
  return url_vars.category;
}

// initial drawing of cards on page load, considering the URL parameters for which groups to display
function drawCards(){
  var category = getCategoryFromUrl();
  redrawCards(category);
  redrawSelector(category);
}

// redrawCards - iterate through all the cards on the page. show the ones in the selected category, and hide all the others
function redrawCards(selected_category){
  $('.card-wrap').each(function(){
    var my_groups = $(this).children('.card').data('group'); // find all the categories for this card
    if (my_groups && my_groups.includes(selected_category)) { // if the card belongs to this category
      $(this).show(); // display it
      // console.log($(this).children('.card').data('activity'));
    } else {
      $(this).hide(); // otherwise, hide it
    }
  });
}

// what happens when user selects a card
function selectACard(){
  data = getCardActivity($(this)); // read card...
  moveToWizardStep(2,data); // move to next step
}

//
function getCardActivity($elem) {
  var activity = $elem.data('activity');
  var data = { activity: activity };
  return data;
}

//
function drawCustomCardBuilder() {
  if ($('#customizer').length) { // does the customizer exist? if so, customize it
    var url_vars = getUrlVars();
    var activity = url_vars.activity;
    if (activity == 'custom') {
      var $card_title = $('#customizer .card-title');
      $card_title.after("<input id=\"custom_title\" placeholder=\"+ Activity...\" maxlength=\"20\" />").remove();
    }
    $('#customizer .card-title').html(activity);
    // $('#customizer .card-title').hide();
    // $('#customizer .card-title').fadeIn(500, function(){
    //   // Animation complete
    // });
    $('#activity_img').attr("src",imageURL["healify_" + activity]);
  }
}

function moveToWizardStep(step,data) {
  if (step==1) {
  } else if (step==2) {
    var activity = data.activity;
    window.location = "activity2.html?activity="+activity+"&title1="+"&title2=";
  }
}

// Document ready sequence
$(document).ready(function(){
  if (isSignedIn){
    console.log('signed in');
    $('#continue').hide();
  } else {
    console.log('signed out');
    $('#checkin').hide();
  }
  navigation(); // set up any navigation controls
  categorySelection(); // set up the category selection behavior
  drawCards(); // initial page load card draw
  cardSelection(); // set up card selection behavior
  drawCustomCardBuilder(); // draw the custom card on check-in screen
  $('#checkin').click(function(){
    const currActivity = getUrlVars().activity;
    base('checkins').create([
      {
        "fields": {
          "Name": localStorage.getItem('userName'),
          "Activity": currActivity,
          "Title": $('#activityTitle').val(),
          "Description": $('#activityDescription').val(),
          "Flower": localStorage.getItem('selectedFlowerName')
        }
      }
    ], function(err, records) {
      if (err) {
        console.error(err);
        return;
      }
      alert('Woohoo! Checked in successfully.');
    });

  });
  $('#continue').click(function(){
    alert('This feature is in progress, but you can still use it! Take a screenshot of this page, then post to the Facebook community. Thanks - Healify Wellness Team');
  });

});
